module.exports = __webpack_public_path__ + "static/img/receipt-paper.d74c63c6.png";